"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _react = _interopRequireWildcard(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _ModalCloseButton = _interopRequireDefault(require("./ModalCloseButton"));
var _TertiaryButton = _interopRequireDefault(require("../Buttons/TertiaryButton"));
var _ModalStyles = require("./ModalStyles");
var _base = require("../themes/_base");
var _excluded = ["trigger", "triggerText", "children", "shouldCloseOnOverlayClick", "withCloseButton", "h", "height", "automationHook", "onRequestClose", "isOpen"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** Define initial state of the modal */
  defaultOpen: _propTypes["default"].bool,
  /** Custom element to be used for trigger */
  trigger: _propTypes["default"].func,
  /** Text for the default Modal trigger button */
  triggerText: _propTypes["default"].string,
  /** Children to be rendered inside the modal
   * Children can also be passed as a function. That function will receive as argument the closeModal method to close the modal
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node, _propTypes["default"].func]),
  /** When 'true' render a close button in upper corner */
  withCloseButton: _propTypes["default"].bool,
  /** When 'true' close the modal when the overlay is clicked */
  shouldCloseOnOverlayClick: _propTypes["default"].bool,
  /** Other props related to styling ---------------
   *
   * TO DO: remove them form here and just use `...modalStylePropTypes,` after storybook can see them
   * Specify a width for the modal window - if this is bigger than the current window width, width will be limited to 100% */
  w: _propTypes["default"].string,
  /** DEPRECATED width prop */
  width: _propTypes["default"].string,
  /** Specify a fixed height for the modal window */
  h: _propTypes["default"].string,
  /** DEPRECATED height prop */
  height: _propTypes["default"].string,
  /** Specify a padding for the modal window. If none is provided, it pads with base space */
  p: _propTypes["default"].oneOf(_base.spaceTypes),
  /** Give a backgroundColor for the Modal Content */
  backgroundColor: _propTypes["default"].string,
  /** When you don't want the modal to be centered, you can position it relative to the top or bottom of the screen;
   * you can combine this with the offset prop, that will give it a different margin   */
  verticalPosition: _propTypes["default"].oneOf(["bottom", "top", "center"]),
  /** When positioning the modal vertically, you may wanna specify an offset from top/ bottom
   * which will add a margin top/bottom - so it can be any valid css string for margin
   * NOTE: this prop only works if verticalPosition is set to "top" or "bottom"
   */
  offset: _propTypes["default"].string,
  /** Callback for closing the modal. It's used to determine if the modal is
   *  controlled. This function should change the value passed to isOpen.
   */
  onRequestClose: _propTypes["default"].func,
  /** The modal state if it's a controlled modal or the initial state if it's an uncontrolled modal. */
  isOpen: _propTypes["default"].bool,
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string
};
var defaultProps = {
  shouldCloseOnOverlayClick: true,
  withCloseButton: true,
  verticalPosition: "top",
  offset: "60px",
  w: "900px"
};
exports.defaultProps = defaultProps;
var Modal = function Modal(_ref) {
  var trigger = _ref.trigger,
    triggerText = _ref.triggerText,
    children = _ref.children,
    shouldCloseOnOverlayClick = _ref.shouldCloseOnOverlayClick,
    withCloseButton = _ref.withCloseButton,
    h = _ref.h,
    height = _ref.height,
    automationHook = _ref.automationHook,
    onRequestClose = _ref.onRequestClose,
    isOpen = _ref.isOpen,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isControlled = (0, _isFunction["default"])(onRequestClose);
  var _useState = (0, _react.useState)(isOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isUncontrolledOpen = _useState2[0],
    setIsUncontrolledOpen = _useState2[1];
  var openModal = (0, _react.useCallback)(function () {
    return setIsUncontrolledOpen(true);
  }, []);
  var closeModal = (0, _react.useCallback)(function () {
    return setIsUncontrolledOpen(false);
  }, []);
  var InnerWrapper = (h !== null && h !== void 0 ? h : height) ? _ModalStyles.FixedHeightContentWrapper : _react["default"].Fragment;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isControlled && (trigger ? /*#__PURE__*/_react["default"].createElement(trigger, {
    onClick: openModal
  }) : /*#__PURE__*/_react["default"].createElement(_TertiaryButton["default"], {
    onClick: openModal
  }, triggerText || "Open Modal")), /*#__PURE__*/_react["default"].createElement(_ModalStyles.ModalStyled, _extends({
    isOpen: isControlled ? isOpen : isUncontrolledOpen,
    onRequestClose: onRequestClose !== null && onRequestClose !== void 0 ? onRequestClose : closeModal,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    ariaHideApp: false,
    withCloseButton: withCloseButton,
    h: h !== null && h !== void 0 ? h : height,
    automationHook: automationHook
  }, rest), withCloseButton && /*#__PURE__*/_react["default"].createElement(_ModalCloseButton["default"], _extends({
    onClick: isControlled ? onRequestClose : closeModal
  }, (0, _automationHooks.hook)(automationHook, "close-button"))), /*#__PURE__*/_react["default"].createElement(InnerWrapper, null, (0, _isFunction["default"])(children) ? children(isControlled ? onRequestClose : closeModal) : children)));
};
Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.displayName = "Modal";
Modal.Box = _ModalStyles.Box;
Modal.Footer = _ModalStyles.Footer;
var _default = Modal;
exports["default"] = _default;